import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { MatIconRegistry, MatIconRegistry as MatIconRegistryClass } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { DocumentThemeService } from './core/services/document-theme.service';
import { RaygunService } from './core/services/raygun.service';
import { LanguageService } from './core/services/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
    private readonly documentThemeService: DocumentThemeService,
    private readonly raygunService: RaygunService,
    private readonly titleService: Title,
    private readonly translateService: TranslateService,
    private readonly languageService: LanguageService,
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: string) {
  }
  
  ngOnInit(): void {
    // On server render the custom theme style attribures
    if (isPlatformServer(this.platformId)) {
      this.raygunService.apply();
    }
    else {

    }

    this.documentThemeService.apply();
    this.addCustomSvgIcons();
    this.setPageTitle();
    this.subscribeToLanguageChanges();
  }

  private setPageTitle(): void {
    this.translateService.get('Common.PageTitle').subscribe((translation: string) => {
      this.titleService.setTitle(translation);
    });
  }

  private subscribeToLanguageChanges(): void {
    this.languageService.currentLanguage$.subscribe(() => {
      this.setPageTitle();
    });
  }

  private addCustomSvgIcons(): void {
    const baseUrl = this.document.location.origin;

    this.matIconRegistry.addSvgIcon(
      'excel',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/assets/images/excel.svg`)
    );

    this.matIconRegistry.addSvgIcon(
      'pdf',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/assets/images/pdf.svg`)
    );

    this.matIconRegistry.addSvgIcon(
      'word',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/assets/images/word.svg`)
    );

    this.matIconRegistry.addSvgIcon(
      'linkedin',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/assets/images/linkedin.svg`)
    );
    
    this.matIconRegistry.addSvgIcon(
      'note',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/assets/images/canvas/note.svg`)
    );
    
    this.matIconRegistry.addSvgIcon(
      'smallNote',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/assets/images/canvas/smallNote.svg`)
    );
    
    this.matIconRegistry.addSvgIcon(
      'comment',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/assets/images/canvas/comment.svg`)
    );

    this.matIconRegistry.addSvgIcon(
      'smallComment',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/assets/images/canvas/smallComment.svg`)
    );
    
    this.matIconRegistry.addSvgIcon(
      'text',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/assets/images/canvas/text.svg`)
    );
    
    this.matIconRegistry.addSvgIcon(
      'smallText',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/assets/images/canvas/smallText.svg`)
    );
    
    this.matIconRegistry.addSvgIcon(
      'help',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/assets/images/canvas/help.svg`)
    );
  }
}
